<template>
  <el-container direction="vertical" class="tg-404--wrapper">
    <el-row type="flex" align="middle" justify="center" class="tg-404--limit">
      <div class="bg"></div>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="tg-404--service">
      <div class="tg-404-24h-btn" @click="handleServiceClick('24h')"></div>
      <div
        class="tg-404-wechat-btn"
        @click="handleServiceClick('wechat')"
      ></div>
      <div class="tg-404-qq-btn" @click="handleServiceClick('qq')"></div>
    </el-row>
    <el-row type="flex" align="middle" justify="center">
      <tg-button
        class="tg-404-forum-btn"
        @click.native="handleGoToForumBtnClick"
        >{{ $t("component.btn.gotoForum") }}</tg-button
      >
    </el-row>
    <tg-dialog
      :showIcon="false"
      :title="title"
      :visible.sync="showDialog"
      append-to-body
      top="25vh"
      :width="qrcode ? '50%' : '20%'"
    >
      <el-row type="flex" justify="center" align="middle">
        <el-image :src="qrcode" :alt="title" v-if="qrcode">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>

        <span
          v-else
          style="text-align: center; font-size:36px;"
          class="text-red"
          v-html="$t('component.dialog.customer_service.fix')"
        >
        </span>
      </el-row>
    </tg-dialog>
  </el-container>
</template>

<script>
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog";
import apis from "@/apis";

export default {
  components: {
    TgButton,
    TgDialog,
  },
  data() {
    return {
      title: "",
      serviceData: {},
      showDialog: false,
      showLoading: false,
      qrcode: "",
      iframe: {
        src: "",
      },
    };
  },
  created() {
    this.$store.commit("breadcrumb/clear");
    apis.app.getService().then((response) => {
      this.serviceData = response.data;
    });
  },
  methods: {
    handleServiceClick(item) {
      this.title = this.$t("component.service." + item);
      if ("24h" == item) {
        this.qrcode = "";
        this.$store.dispatch("service/showService", this.$user);
      } else {
        this.qrcode = this.serviceData[item + "Image"];
        this.showDialog = true;
        this.showIframe = false;
      }
    },
    handleGoToForumBtnClick() {
      window.open("https://c.tg6000.net");
    },
  },
};
</script>
